import { FakDokumentStavkaView } from './fak-dokument-stavka-view';
import { FakDokumentStavka } from './fak-dokument-stavka';
import { Component, Input } from "@angular/core";
import { BaseDetailListSum, UserService } from 'yt-ng-framework';
import { DecimalPipe } from '@angular/common';
//import { PARAMETERS } from '@angular/core/src/util/decorators';
import { FakDokumentStavkaIzvozView } from './izvoz/fak-dokument-stavka-izvoz-view';
import { FakDokumentStavkaIzvoz } from './izvoz/fak-dokument-stavka-izvoz';

@Component({
    selector: 'yt-fak-dokument-sum',
    templateUrl: './fak-dokument-sum.component.html'
})
export class FakDokumentSum extends BaseDetailListSum<FakDokumentStavkaView> {
    constructor(
        protected decimalPipe: DecimalPipe,
        protected userService: UserService
    ){
        super();
    }

    @Input() Parameters;

    private _osnovica: number = 0;
    private _porez: number = 0;
    private _ukupno: number = 0;
    private _rabatproc: number = 0;
    private _rabatvred: number = 0;
    private _vrednost: number=0;
    private _avansOsnovica: number = 0;
    private _avansPdv: number = 0;
    private _avansi: string = "";
    private _vrednostIno: number = 0;
    private _rabatIno: number = 0;
    private _ukupnoIno: number = 0;
    private _korekcija: number = 0;

    osnovica: string;
    porez: string;
    ukupno: string;
    rabatproc: string;
    rabatvred: string;
    vrednost: string;
    avansOsnovica: string;
    avansPdv: string;
    avansi: string;
    avansUkupno: string;
    ukupnoZaUplatu: string;
    ino : boolean = false;
    vrednostIno: string;
    rabatIno: string;
    ukupnoIno: string;
    imaAvans : boolean = false;
    valutaISOAlpha3Code : string;
    imaKorekciju: boolean = false;
    korekcija: string;
    komentar: string; 
    statusColor: string;

    calculate(){
        super.calculate();

        this._osnovica = 0;
        this._porez = 0;
        this._ukupno = 0;
        this._rabatproc = 0;
        this._rabatvred = 0;
        this._vrednost =0;
        this._avansOsnovica = 0;
        this._avansPdv = 0;
        this._avansi = "";
        this._vrednostIno = 0;
        this._rabatIno = 0;
        this._ukupnoIno = 0;
        this.imaAvans = false;
        this.ino = false;
        
        this._korekcija = 0;
        this.imaKorekciju = false;

        if (this.Parameters.get(2) != undefined)
            this.ino = this.Parameters.get(2).get(0).Value != null;  
        
        if (this.Parameters.get(3) != undefined)
            this.valutaISOAlpha3Code = this.Parameters.get(3).get(0).Value;  
        
        if (this.Parameters.get(4) != undefined){
            this.korekcija = this.Parameters.get(4).get(0).Value;
            this.imaKorekciju = Number(this.korekcija) !== 0;
            this._korekcija = Number(this.korekcija);
        }

        if(this.Items && this.Items.size > 0){
            if (!this.ino){
                this.Items.forEach((item: FakDokumentStavkaView) => {
                    //this._osnovica += item.Cena * item.Kolicina;
                    //this._ukupno += (item.Cena * item.Kolicina) * (item.Stopa / 100 + 1);
                    //this._porez += (item.Cena * item.Kolicina) * (item.Stopa / 100 + 1) - (item.Cena * item.Kolicina);
                    // this._osnovica += item.Osnovica;
                    // this._porez += item.Porez;
                    // this._ukupno += item.Ukupno;
                    this._osnovica += item.OsnovicaStavke;
                    this._porez += item.PdvStavke;
                    this._ukupno += item.VrednostStavke;
                    //this._ukupno += item.Osnovica+item.Porez;
                    // this._rabatvred += item.RabatVred*item.Kolicina;
                    // this._rabatvred += Number((item.Kolicina*item.Cena*item.RabatProc/100).toFixed(2));
                    // this._vrednost += Number((item.Cena*item.Kolicina).toFixed(2));       
//                    this._rabatvred += item.UkRabat;
//                    this._vrednost += item.Vrednost;                  

                    // 22.08.2023
                    // this._rabatvred += Number((item.Kolicina*item.Cena*item.RabatProc/100).toFixed(2));
                    // this._vrednost += item.Cena*item.Kolicina;
                    this._rabatvred += item.RabatStavke;
                    this._vrednost += item.VrednostPreRabataStavke;
                })         
            }
            else{
                this.Items.forEach((item: FakDokumentStavkaIzvozView) => {
                    // this._osnovica += item.Osnovica;
                    // this._porez += item.Porez;
                    // this._ukupno += item.Ukupno;
                    this._osnovica += item.OsnovicaStavke;
                    this._porez += item.PdvStavke;
                    this._ukupno += item.VrednostStavke;
                    // this._rabatvred += item.RabatVred*item.Kolicina;
                    // this._rabatvred += Number((item.Kolicina*item.Cena*item.RabatProc/100).toFixed(2));
                    // this._vrednost += Number((item.Cena*item.Kolicina).toFixed(2));      
//                    this._rabatvred += item.UkRabat;
//                    this._vrednost += item.Vrednost;

                    // 22.08.203
                    // this._rabatvred += Number((item.Kolicina*item.Cena*item.RabatProc/100).toFixed(2));
                    // this._vrednost += item.Cena*item.Kolicina;

                    this._rabatvred += item.RabatStavke;
                    this._vrednost += item.VrednostPreRabataStavke;

                    // this._vrednostIno += Number((item.CenaUValuti*item.Kolicina).toFixed(2));
                    // this._rabatIno += Number((item.RabatVredPoJmUValuti*item.Kolicina).toFixed(2));
//                    this._vrednostIno += rounding(item.CenaUValuti*item.Kolicina, 2);
//                    this._rabatIno += rounding(item.RabatVredPoJmUValuti*item.Kolicina, 2);
 
                    // 22.08.203
                    this._vrednostIno += item.CenaUValuti*item.Kolicina;
                    this._rabatIno += item.RabatVredUValuti*item.Kolicina;

                                     
                })  
                this._ukupnoIno += this._vrednostIno -this._rabatIno;          
            }
            
        }

        
        if (this.Parameters && this.Parameters.size>0 &&
            this.Parameters.get(1) && this.Parameters.get(1).size>0)
        {
                this._avansOsnovica=this.Parameters.get(1).get(0).Value["UplacenAvansOsnovica"];
                this._avansPdv=this.Parameters.get(1).get(0).Value["PdvNaIznosAvansa"];
                this._avansi=this.Parameters.get(1).get(0).Value["Avansi"];
                this.imaAvans = this._avansOsnovica != undefined && this._avansOsnovica != 0;
                this.komentar=this.Parameters.get(1).get(0).Value["Komentar"];
                this.statusColor=this.Parameters.get(1).get(0).Value["StatusColor"];

        }
        else
        {
            this.komentar="";
        }
        this.osnovica = this.decimalPipe.transform(this._osnovica, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        this.ukupno = this.decimalPipe.transform(this._ukupno, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        this.porez = this.decimalPipe.transform(this._porez, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        this.rabatvred = this.decimalPipe.transform(this._rabatvred, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        this.vrednost = this.decimalPipe.transform(this._vrednost, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        this.avansOsnovica = this.decimalPipe.transform(this._avansOsnovica, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        this.avansPdv = this.decimalPipe.transform(this._avansPdv, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        this.avansi = this._avansi;
        this.avansUkupno = this.decimalPipe.transform(this._avansOsnovica+this._avansPdv, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        this.korekcija = this.decimalPipe.transform(this._korekcija, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        this.ukupnoZaUplatu = this.decimalPipe.transform(this._ukupno-this._avansOsnovica-this._avansPdv+this._korekcija, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        if (this.ino){
            this.vrednostIno = this.decimalPipe.transform(this._vrednostIno, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
            this.rabatIno = this.decimalPipe.transform(this._rabatIno, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
            this.ukupnoIno = this.decimalPipe.transform(this._ukupnoIno, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
        }
    }
}

function rounding(number: number, precision: number): number{
    return Number((Math.round(Number(number + "e+" + precision)) +"e-" + precision));
}